import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalText from '../common/LocalText';
import { PHASES } from '../../constants/gameSchedule';

/** Upcoming / Running / Ended — the phase of a quiz against its dates (the API calls "Running" live). */
export function PhaseChip({ phase }) {
  const cfg = PHASES[phase];
  if (!cfg) return null;
  return (
    <Box
      component="span"
      data-testid="phase-chip"
      sx={{
        display: 'inline-flex', alignItems: 'center', px: 1, py: 0.25, borderRadius: '6px', whiteSpace: 'nowrap',
        bgcolor: cfg.bg, border: `1px solid ${cfg.border}`,
      }}
    >
      <Typography component="span" sx={{ fontSize: '0.6875rem', fontWeight: 700, color: cfg.color, lineHeight: 1.4 }}>
        <LocalText>{cfg.label}</LocalText>
      </Typography>
    </Box>
  );
}

/** A small "Locked" tag for a quiz that has started: it can no longer be edited or deleted. */
export function LockedTag() {
  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', px: 0.75, py: 0.125, borderRadius: '6px', bgcolor: '#f1f5f9', border: '1px solid #e2e8f0' }}
    >
      <Typography component="span" sx={{ fontSize: '0.625rem', fontWeight: 700, color: '#475569', lineHeight: 1.5, textTransform: 'uppercase', letterSpacing: 0.4 }}>
        <LocalText>Locked</LocalText>
      </Typography>
    </Box>
  );
}
